import React, { useState } from "react";
import { Paper } from "@mui/material";
import classes from "./myteam.module.css";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { InputAdornment } from "@mui/material";
import {
  TeamMemberStatus,
  locationTimeFilter,
} from "../../../utilities/constants";
import { BsThreeDotsVertical } from "react-icons/bs";
import Button from "@mui/material/Button";
import {
  CardContent,
  MenuItem,
  Menu,
  Typography,
  Card,
  Avatar,
} from "@mui/material";
import { stringAvatar, generateColor } from "../../../utilities/commonFunctions";
import { BiSortAlt2 } from "react-icons/bi";
import image from "../../../assets/images/New team members-rafiki 1.png";
import { IoAddCircleOutline } from "react-icons/io5";
import AddMemberModal from "./AddMemberModal";
import { useDispatch, useSelector } from "react-redux";
import {
  CREATE_TEAM,
  DELETE_MEMBER,
  TEAM_LIST,
  SUBSCRIPTION_LIST,
  MY_SUBSCRIPTION,
  PAYMENT_SUCCESS,
  RENEW_SUBS,
} from "../../../api-calls/api-urls";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { Checkbox, FormControlLabel, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import loadRazorpayScript from "../../../utilities/loadRazorpay";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";
import {
  currentEditTeam,
  saveTeamMemberStatusFilter,
} from "../../../Redux/actions/team-actions";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  ArrowDownIcon,
  BrudCrumbBackIcon,
  BrudCrumbNextIcon,
  DeleteBinIcons,
  EditPenIcon,
  FilterIcon,
  RoundAddIcon,
  SearchIcon,
} from "../../../components/Icons";
import AlertBox from "../../../components/AlertBox";
import { saveLocationTimeFilter } from "../../../Redux/actions/location-action";
import { useRazorpaySubscriptionCheckout } from "../../../hooks/useRazorpaySubscriptionCheckout";

const CreateTeam = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { startRecurringCheckout } = useRazorpaySubscriptionCheckout();
  const [typecall, setTypeCall] = useState();
  const [selected, setSelected] = useState();
  const [teamName, setTeamName] = useState();
  const [serachValue, setSearchValue] = useState();
  const [anchorEl, setAnchorEl] = useState();
  const [modletoggle1, setModleToggle1] = useState();
  const [error, setError] = useState();
  const [showAlert, setShowAlert] = useState();
  const [openMenu, setOpenMenu] = useState();
  const [plans, setPlans] = useState([]);
  const [members, setMembers] = useState([]);
  const [anchorEl1, setAnchorEl1] = useState();
  const [modletoggle, setModleToggle] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]); // State to store selected values
  const [selectedValues1, setSelectedValues1] = useState();
  const [billingPeriod, setBillingPeriod] = useState("monthly");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const editTeam = useSelector((state) => state.teams.editTeam);
  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount (getLanguagedataFunction is idempotent)

  useEffect(() => {
    if (editTeam) {
      setTeamName(editTeam.team_name);
      setMembers(editTeam.team_members);
    }
  }, [editTeam]);
  const handleClick = (event, name) => {
    if (name === "ref1") {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl1(event.currentTarget);
    }
  };
  const handleMenuclick = (event, item) => {
    setSelected(item);
    setOpenMenu(event.currentTarget);
  };

  const getPlansDetails = async () => {
    try {
      const { data } = await authApi.get(SUBSCRIPTION_LIST);
      if (data && data.length > 0) {
        setPlans(data);
        // Default to first plan if not editing
        if (!editTeam && !selectedPlan) {
          setSelectedPlan(data[0]);
        }
      } else {
        console.warn("No plans received from API");
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      toast.error("Failed to load subscription plans. Please refresh.");
    }
  };

  useEffect(() => {
    getPlansDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStatusCheckbox = (value) => {
    const isSelected = selectedValues.includes(value);

    if (value === "all") {
      if (isSelected) {
        // Unselect all checkboxes
        setSelectedValues([]);
        dispatch(saveTeamMemberStatusFilter([]));
      } else {
        // Select all checkboxes
        setSelectedValues([...TeamMemberStatus]);
        dispatch(saveTeamMemberStatusFilter([...TeamMemberStatus]));
      }
    } else {
      // Toggle the selection of individual checkboxes
      let newSelectedValues = [];

      if (isSelected) {
        newSelectedValues = selectedValues.filter((v) => v !== value);
      } else {
        newSelectedValues = [...selectedValues, value];
      }
      setSelectedValues(newSelectedValues);
      dispatch(saveTeamMemberStatusFilter([newSelectedValues]));

      const areAllSelected = TeamMemberStatus.filter(
        (item) => item !== "all"
      ).every((item) => newSelectedValues.includes(item));

      // Check the "All" checkbox if all others are selected
      if (areAllSelected) {
        setSelectedValues((prevSelected) => [...prevSelected, "all"]);
        dispatch(saveTeamMemberStatusFilter([...newSelectedValues, "all"]));
      } else {
        // Uncheck the "All" checkbox if any other checkbox is unselected
        setSelectedValues((prevSelected) =>
          prevSelected.filter((item) => item !== "all")
        );
        dispatch(
          saveTeamMemberStatusFilter(
            newSelectedValues.filter((item) => item !== "all")
          )
        );
      }
    }
  };

  const handleTimeCheckBox = (value) => {
    setSelectedValues1(value);
    dispatch(saveLocationTimeFilter(value));
  };

  const handleMenuItemClick = async (e, name) => {
    try {
      e.stopPropagation();
      if (name === "edit") {
        setModleToggle(true);
        setTypeCall("edit");
      } else if (name === "delete") {
        if (selected._id) {
          const entry = {
            _id: selected._id,
          };
          await authApi.delete(
            `${TEAM_LIST}/${editTeam._id}${DELETE_MEMBER}`,
            {
              headers: { Authorization: getAuthorizationHeader() },
              data: entry,
            }
          );
          getOneTeamData(window.location.pathname);
        } else {
          const newList = members.filter(
            (item) => item.mobile_number !== selected.mobile_number
          );
          setMembers(newList);
        }
        //getData();
      }
      handleClose();
    } catch (error) {
      // Intentionally ignored — not surfaced to the user
    }
  };
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("/update")) {
      getOneTeamData(path.toLowerCase());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!editTeam, selectedValues, selectedValues1, serachValue]);
  const getOneTeamData = async (path) => {
    try {
      const arr = path.split("/");
      const filterArray = {
        status: selectedValues,
      };
      const { data } = await authApi.post(
        `${TEAM_LIST}/${
          arr[arr?.length - 1]
        }?search=${serachValue}&sortBy=${selectedValues1}`,
        filterArray,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      dispatch(currentEditTeam(data));
    } catch (error) {
      // Intentionally ignored — not surfaced to the user
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
    setOpenMenu(null);
  };
  const getPlanDetails = (plan) => {
    if (!plan || !plan.durations || plan.durations.length === 0) return null;
    
    // Try to find exact match
    let durationObj = plan.durations.find((d) => {
      const dur = d.duration?.toLowerCase();
      if (billingPeriod === "monthly") {
        return (
          dur === "monthly" ||
          dur === "month" ||
          dur === "monthly/month" ||
          dur === "month/monthly" ||
          dur === "1 month"
        );
      } else {
        return (
          dur === "yearly" ||
          dur === "year" ||
          dur === "annually" ||
          dur === "annual" ||
          dur === "year/yearly" ||
          dur === "yearly/year" ||
          dur === "12 months" ||
          dur === "1 year"
        );
      }
    });

    // Fallback if no exact match found for current billing period
    if (!durationObj && plan.durations.length > 0) {
        durationObj = plan.durations[0];
    }

    return durationObj;
  };

  const handlePayment = async (plan, durationObj) => {
    try {
      // Durations backfilled with a Razorpay plan support real auto-debit;
      // anything else falls back to the legacy one-time-payment flow below.
      if (durationObj?.razorpay_plan_id) {
        return new Promise((resolve) => {
          startRecurringCheckout({
            subscriptionId: plan._id,
            durationId: durationObj._id,
            description: `Subscription: ${plan.packageName}`,
            onAuthorized: async (_response, subscriptionData) => {
              resolve(subscriptionData?.customer_subscription_id || true);
            },
            onCancelled: () => resolve(false),
            onFailed: () => resolve(false),
          }).catch((error) => {
            console.error("Payment Error:", error);
            toast.error("Something went wrong during payment.");
            resolve(false);
          });
        });
      }

      const res = await loadRazorpayScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!res) {
        toast.error("Razorpay SDK failed to load. Are you online?");
        return false;
      }

      // Create the order first, so the server can price the checkout from
      // it and the payment can be confirmed against it.
      const subRes = await authApi.post(
        MY_SUBSCRIPTION,
        {
          subscriptionid: plan._id,
          durationid: durationObj._id,
        },
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      const dbOrder = subRes.data?.data;
      if (!dbOrder?._id) {
        toast.error("Unable to create order. Please try again.");
        return false;
      }

      const basePrice = parseFloat(durationObj.price?.$numberDecimal || durationObj.price || 0);
      const price =
        dbOrder.order_payable ?? Math.round(basePrice * 1.18 * 100) / 100; // include 18% GST

      // Create order
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/my-subscriptions/create-order`,
        {
          amount: price,
          currency: "INR",
          receipt: `receipt_${dbOrder._id}`,
          order_id: dbOrder._id,
        },
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );

      return new Promise((resolve) => {
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: data.order.amount,
          currency: data.order.currency,
          name: "Team Player App",
          description: `Subscription: ${plan.packageName}`,
          order_id: data.order.id,
          handler: async (response) => {
            const verifyRes = await axios.post(
              `${process.env.REACT_APP_API_URL}/my-subscriptions/verify-order`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              },
              {
                headers: { Authorization: getAuthorizationHeader() },
              }
            );

            if (verifyRes.data.success) {
              // Confirm payment on server, with the Razorpay proof it
              // needs before it will activate a paid order.
              const payRes = await authApi.post(
                PAYMENT_SUCCESS,
                {
                  userid: dbOrder.user_id,
                  orderid: dbOrder._id,
                  payment_details: {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                  },
                },
                {
                  headers: { Authorization: getAuthorizationHeader() },
                }
              );
              resolve(payRes.data?.customerSubscriptionId || true);
            } else {
              toast.error("Payment Verification Failed.");
              resolve(false);
            }
          },
          theme: { color: "#528FF0" },
          modal: {
            ondismiss: () => {
              toast.info("Payment Cancelled!");
              resolve(false);
            },
          },
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
      });
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error("Something went wrong during payment.");
      return false;
    }
  };

  const handleSubmit = async () => {
    try {
      if (editTeam) {
        const userEntry = {
          team_name: teamName,
          // _id (when the member already exists server-side) tells the
          // backend to update that member in place rather than treat them
          // as a brand-new one — omitting it entirely used to make every
          // save regenerate every member's _id, breaking any previously
          // saved link to them (report URLs, etc). A member added locally
          // in this edit session only has AddMemberModal's client-side
          // temp `id`, never a real `_id`, so it's correctly left out and
          // the backend adds them as new.
          team_members: members.map(m => ({
            ...(m._id ? { _id: m._id } : {}),
            user_name: m.user_name || m.name,
            mobile_number: m.mobile_number,
            department: m.department || (m.department_data && m.department_data[0]?._id)
          })),
        };
        dispatch(currentEditTeam(null));
        await authApi.put(
          `${CREATE_TEAM}/${editTeam._id}`,
          userEntry,
          { headers: { Authorization: getAuthorizationHeader() } }
        );
        toast.success("Team updated successfully");
        navigate("/my-team");
        return;
      }

      if (!selectedPlan) {
        toast.error("Please select a subscription plan");
        return;
      }

      const durationObj = getPlanDetails(selectedPlan);
      if (!durationObj) {
        toast.error("Selected plan is not available for this billing period");
        return;
      }

      if (members.length === 0) {
        toast.error("Please add at least one member");
        return;
      }

      setIsProcessingPayment(true);
      const price = parseFloat(
        durationObj.price?.$numberDecimal || durationObj.price || 0
      );

      let customerSubscriptionId = null;

      if (price > 0) {
        const payResult = await handlePayment(selectedPlan, durationObj);
        if (!payResult) {
          setIsProcessingPayment(false);
          return;
        }
        if (typeof payResult === "string") customerSubscriptionId = payResult;
      } else {
        // Free plan: select subscription directly
        const subEntry = {
          subscriptionid: selectedPlan._id,
          durationid: durationObj._id,
        };
        const subRes = await authApi.post(MY_SUBSCRIPTION, subEntry, {
          headers: { Authorization: getAuthorizationHeader() },
        });
        if (subRes.data) {
          const payRes = await authApi.post(
            PAYMENT_SUCCESS,
            {
              userid: subRes.data.data.user_id,
              orderid: subRes.data.data._id,
            },
            { headers: { Authorization: getAuthorizationHeader() } }
          );
          customerSubscriptionId = payRes.data?.customerSubscriptionId || null;
        }
      }

      const userEntry = {
        team_name: teamName,
        team_members: members.map(m => ({
          user_name: m.user_name || m.name,
          mobile_number: m.mobile_number,
          department: m.department || (m.department_data && m.department_data[0]?._id)
        })),
      };

      const teamRes = await authApi.post(CREATE_TEAM, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const newTeamId = teamRes.data?._id;

      if (customerSubscriptionId && newTeamId) {
        try {
          await authApi.post(
            RENEW_SUBS,
            { team_id: newTeamId, avail: { _id: customerSubscriptionId }, type: "new" },
            { headers: { Authorization: getAuthorizationHeader() } }
          );
        } catch (renewErr) {
          console.warn("Failed to link subscription to team:", renewErr);
        }
      }

      toast.success("Team created successfully");
      navigate("/my-team");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error creating team");
    } finally {
      setIsProcessingPayment(false);
    }
  };
  const CloseForm = (status, data) => {
    if (data) {
      const memberPResent = members.filter(
        (item) =>
          (item.id && item.id === data.id) || (item._id && item._id === data.id)
      );
      if (memberPResent?.length > 0) {
        const newState = members.map((item) => {
          if (item.id === data.id) {
            return {
              ...item,
              user_name: data.user_name,
              mobile_number: data.mobile_number,
              department: data.department,
              department_name: data.department_name,
            };
          }
          if (item._id === data.id) {
            return {
              ...item,
              user_name: data.user_name,
              mobile_number: data.mobile_number,
              department: data.department,
              department_name: data.department_name,
            };
          }
          return item;
        });
        setMembers(newState);
      } else {
        const check = members.filter(
          (item) => item.mobile_number === data.mobile_number
        );
        if (check?.length > 0) {
          setError("There is already a member with this mobile number");
          setShowAlert(true);
        } else {
          const array = [...members, data];
          setMembers(array);
        }
      }
    }
    setModleToggle(status);
    setModleToggle1(status);
  };

  const handleAddMemberModal = () => {
    const currentLimit = editTeam
      ? editTeam.customer_subscription?.no_team_members
      : selectedPlan?.noOfTeamMembers || 10;

    if (members?.length < currentLimit) {
      setModleToggle1(true);
      setSelected();
      setTypeCall("create");
    } else {
      setError(`You can add only ${currentLimit} members`);
      setShowAlert(true);
    }
  };

  const clickClearAll = (name) => {
    name([]);
  };

  return (
    <div>
      {ln ? (
        <div>
          <Box sx={{ mb: 3 }} className={classes.brudCrumb}>
            <span onClick={() => navigate(-1)}>
              <BrudCrumbBackIcon />
            </span>
            <span onClick={() => navigate("/my-team")}>{ln.my_team}</span>
            <BrudCrumbNextIcon />
            <span style={{ color: "#6A6E8A" }}>
              {editTeam ? editTeam.team_name : "Create Team"}
            </span>
          </Box>
          <Paper
            className={`${classes.CreateTeamindex} ${classes.createTeamMaindiv}`}
          >
            <ValidatorForm useref="form" onSubmit={handleSubmit}>
              <div>
                <Typography className={classes.createTeamHeading}>
                  {ln.create_team}
                </Typography>
                <Box sx={{ mb: 3, mt: 2 }}>
                  <label
                    htmlFor="firstNameinput"
                    className={classes.form_lable}
                  >
                    {ln.team_name}*
                  </label>
                  <TextValidator
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="firstNameinput"
                    value={teamName}
                    onChange={(e) => setTeamName(e.target.value)}
                    size="small"
                    validators={["required"]}
                    errorMessages={["Team Name is required"]}
                  />
                </Box>
              </div>
              {!editTeam && (
                <>
                  <hr />
                  <div className={classes.subscriptionSection}>
                    <Typography className={classes.createTeamHeading} sx={{ mb: 2 }}>
                      {ln.select_subscription || "Select Subscription"}
                    </Typography>

                    <div className={classes.billingToggleContainer}>
                      <div className={classes.billingToggle}>
                        <Button
                          className={`${classes.toggleBtn} ${
                            billingPeriod === "monthly" ? classes.toggleBtnActive : ""
                          }`}
                          onClick={() => setBillingPeriod("monthly")}
                        >
                          {ln.monthly || "Monthly"}
                        </Button>
                        <Button
                          className={`${classes.toggleBtn} ${
                            billingPeriod === "annually" ? classes.toggleBtnActive : ""
                          }`}
                          onClick={() => setBillingPeriod("annually")}
                        >
                          {ln.annually || "Annually"}
                        </Button>
                      </div>
                    </div>

                    <div className={classes.plansGrid}>
                      {plans.length > 0 ? (
                        plans.map((plan) => {
                          const durationObj = getPlanDetails(plan);
                          if (!durationObj) return null;

                          const isSelected = selectedPlan?._id === plan._id;
                          const price = parseFloat(
                            durationObj.price?.$numberDecimal || durationObj.price || 0
                          );

                          return (
                            <Card
                              key={plan._id}
                              className={`${classes.planCard} ${
                                isSelected ? classes.planCardSelected : ""
                              }`}
                              onClick={() => setSelectedPlan(plan)}
                            >
                              {isSelected && (
                                <div className={classes.selectedBadge}>
                                  <CheckIcon sx={{ fontSize: 16 }} />
                                </div>
                              )}
                              <CardContent sx={{ p: 3 }}>
                                <div className={classes.planHeader}>
                                  <Typography className={classes.packageName}>
                                    {plan.packageName}
                                  </Typography>
                                  <Typography className={classes.planPrice}>
                                    {price === 0 ? (ln.free || "Free") : `₹${price}`}
                                    {price > 0 && (
                                      <span className={classes.pricePeriod}>
                                        /{billingPeriod === "monthly" ? (ln.month || "mo") : (ln.year || "yr")}
                                      </span>
                                    )}
                                  </Typography>
                                </div>
                                <Typography className={classes.planLimit}>
                                  {ln.upto || "Up to"} {plan.noOfTeamMembers} {ln.members || "members"}
                                </Typography>
                                <ul className={classes.featuresList}>
                                  {plan.features?.slice(0, 4).map((f, i) => (
                                    <li key={i} className={classes.featureItem}>
                                      <div className={classes.featureDot} />
                                      <span>{f.feature || f}</span>
                                    </li>
                                  ))}
                                </ul>
                              </CardContent>
                            </Card>
                          );
                        })
                      ) : (
                        <Typography sx={{ textAlign: "center", width: "100%", py: 4, color: "#6b778c" }}>
                          No subscription plans available at the moment.
                        </Typography>
                      )}
                    </div>
                    <Box
                      sx={{
                        mt: 2,
                        px: 2,
                        py: 1.5,
                        backgroundColor: "#FFF8E1",
                        border: "1px solid #FFE082",
                        borderRadius: "6px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body2" sx={{ color: "#795548", fontWeight: 500 }}>
                        All prices shown are exclusive of GST. 18% GST will be applied at checkout.
                      </Typography>
                    </Box>
                  </div>
                </>
              )}
              <hr />
              <div>
                <div
                  className={classes.teamMembersmainDiv}
                  style={{ alignItems: "center", marginTop: "16px" }}
                >
                  <Typography className={classes.createTeamHeading}>
                    {ln.team_members}
                  </Typography>
                  <Typography className={classes.form_lable}>
                    {members.length}/{editTeam ? editTeam.customer_subscription?.no_team_members : selectedPlan?.noOfTeamMembers || 10}
                  </Typography>
                </div>
                <div
                  className={classes.teamMembersmainDiv}
                  style={{ height: "auto" }}
                >
                  <div>
                    <div className="">
                      <TextValidator
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        placeholder="Search"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        className={classes.teamMemberSearch}
                        id="firstNameinput"
                        value={serachValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex", columnGap: 10 }}>
                    <div style={{ width: "auto" }}>
                      <Button
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        variant="outlined"
                        onClick={(e) => handleClick(e, "ref1")}
                        fullWidth
                        className={classes.filterbtns}
                      >
                        <div
                          className={classes.form_lable}
                          style={{ textTransform: "capitalize" }}
                        >
                          <FilterIcon /> All
                        </div>
                        <div>
                          <ArrowDownIcon />
                        </div>
                      </Button>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <div className={classes.filterHeading}>
                          <h5>Filter</h5>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={classes.claerBtn}
                            onClick={() => clickClearAll(setSelectedValues)}
                          >
                            clear all
                          </a>
                        </div>
                        {TeamMemberStatus.map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              style={{
                                padding: "6px 25px 6px 0",
                                textTransform: "capitalize",
                              }}
                            >
                              <Box sx={{ p: 1 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedValues?.includes(item)}
                                      onChange={() => handleStatusCheckbox(item)}
                                      size="small"
                                    />
                                  }
                                  label={item.replaceAll("_", " ")}
                                />
                              </Box>
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </div>
                    <div style={{ minWidth: "180px" }}>
                      <Button
                        id="basic-button1"
                        aria-controls={open1 ? "basic-menu1" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open1 ? "true" : undefined}
                        onClick={(e) => handleClick(e, "ref2")}
                        variant="outlined"
                        fullWidth
                        className={classes.filterbtns}
                      >
                        <div
                          className={classes.form_lable}
                          style={{
                            textTransform: "capitalize",
                            marginRight: "7px",
                          }}
                        >
                          <BiSortAlt2 /> Newest to Oldest
                        </div>
                        <div>
                          <ArrowDownIcon />
                        </div>
                      </Button>
                      <Menu
                        anchorEl={anchorEl1}
                        open={Boolean(anchorEl1)}
                        onClose={handleClose}
                      >
                        <div className={classes.filterHeading}>
                          <h5>Sort By</h5>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            className={classes.claerBtn}
                            onClick={() => clickClearAll(setSelectedValues1)}
                          >
                            clear all
                          </a>
                        </div>
                        {locationTimeFilter.map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              style={{
                                padding: "6px 25px 6px 0",
                                textTransform: "capitalize",
                              }}
                            >
                              <Box sx={{ p: 1 }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedValues1?.includes(item)}
                                      onChange={() => handleTimeCheckBox(item)}
                                      size="small"
                                    />
                                  }
                                  label={item.replaceAll("_", " ")}
                                />
                              </Box>
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </div>
                  </div>
                </div>
                {members && members?.length > 0 ? (
                  <Box sx={{ mt: 3 }} className={classes.indexpageMainBtn}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleAddMemberModal();
                      }}
                    >
                      <IoAddCircleOutline style={{ marginRight: "5px" }} />
                      {ln.add_member}
                    </Button>
                  </Box>
                ) : null}
                <div className={classes.CreateTeamindex}>
                  {members && members?.length > 0 ? (
                    <div>
                      <div>
                        <div
                          className={`${classes.GridContainer} ${classes.TeamMemberGridcontaoiner}`}
                        >
                          {members.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                {item.user_name || item.name ? (
                                  <Card
                                    key={item.index}
                                    className={classes.teamCard}
                                  >
                                    <CardContent
                                      sx={{ paddingBottom: "16px !important" }}
                                    >
                                      <div
                                        className={`${classes.teamCardContainer} ${classes.teamMembercardContainer}`}
                                      >
                                        {item.user_name || item.name ? (
                                          <Avatar
                                            {...stringAvatar(
                                              item.user_name || item.name
                                            )}
                                            sx={{
                                              bgcolor: `${generateColor(
                                                item.user_name || item.name
                                              )}`,
                                            }}
                                          />
                                        ) : null}
                                        {item.label}
                                        <div className={classes.memberCardText}>
                                          <Typography
                                            className={classes.form_lable}
                                          >
                                            {ln.team_member}
                                          </Typography>
                                          <Typography
                                            className={classes.CardValues}
                                          >
                                            {item.user_name || item.name}
                                          </Typography>
                                        </div>
                                        <div className={classes.cardMenuButton}>
                                          <Button
                                            variant="text"
                                            className={`${classes.CardMenu} ${classes.member}`}
                                            onClick={(e) =>
                                              handleMenuclick(e, item)
                                            }
                                          >
                                            <BsThreeDotsVertical />
                                          </Button>
                                          <Menu
                                            anchorEl={openMenu}
                                            open={Boolean(openMenu)}
                                            onClose={handleClose}
                                          >
                                            <MenuItem
                                              key={`edit${item.index}`}
                                              className={classes.EditMenuTeam}
                                              value={index}
                                              onClick={(e) =>
                                                handleMenuItemClick(e, "edit")
                                              }
                                            >
                                              <EditPenIcon />
                                              <span>{ln.edit_member}</span>
                                            </MenuItem>
                                            <MenuItem
                                              key={`delete${item.index}`}
                                              onClick={(e) =>
                                                handleMenuItemClick(e, "delete")
                                              }
                                            >
                                              <DeleteBinIcons />
                                              <span>{ln.delete_member}</span>
                                            </MenuItem>
                                          </Menu>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className={classes.membercardFooter}>
                                        <div
                                          className={`${classes.memberCardText} ${classes.memberTextsubContainer}`}
                                        >
                                          <Typography
                                            className={classes.form_lable}
                                          >
                                            {ln.mobile_number}
                                          </Typography>
                                          <Typography
                                            className={classes.CardValues}
                                          >
                                            +91 {item.mobile_number}
                                          </Typography>
                                        </div>
                                        <div
                                          className={`${classes.memberCardText} ${classes.memberTextsubContainer}`}
                                        >
                                          <Typography
                                            className={classes.form_lable}
                                          >
                                            {ln.departments}
                                          </Typography>
                                          <Typography
                                            className={classes.CardValues}
                                          >
                                            {item && item.department_name
                                              ? item.department_name
                                              : item &&
                                                item.department_data &&
                                                item.department_data?.length >
                                                  0 &&
                                                item.department_data[0]
                                                  .department_name
                                              ? item.department_data[0]
                                                  .department_name
                                              : null}
                                          </Typography>
                                        </div>
                                      </div>
                                    </CardContent>
                                  </Card>
                                ) : null}
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={classes.imagePagemaindiv}>
                      <img
                        src={image}
                        alt="createTeam"
                        className={classes.addmemberImage}
                      />
                      <Typography
                        className={`${classes.imagePageText} ${classes.createTeamImageText}`}
                        variant="h5"
                      >
                        {ln.no_member_data}
                      </Typography>
                      <Button
                        variant="text"
                        className={classes.imagepagebtn}
                        onClick={() => {
                          setModleToggle1(true);
                          setSelected();
                          setTypeCall("create");
                        }}
                      >
                        <RoundAddIcon />
                        {ln.add_member}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
              <div className={classes.CreateTeamSubmitSection}>
                <Button
                  variant="outlined"
                  style={{
                    textTransform: "capitalize",
                    border: "2px solid #1976d2",
                    color: "#1976d2",
                  }}
                  onClick={() => navigate("/my-team")}
                >
                  {ln.cancel}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isProcessingPayment}
                  style={{ textTransform: "capitalize" }}
                >
                  {isProcessingPayment ? (ln.processing || "Processing...") : (editTeam ? ln.submit : ln.submit)}
                </Button>
              </div>
            </ValidatorForm>
          </Paper>
          {modletoggle && editTeam && selected ? (
            <AddMemberModal
              modalClose={CloseForm}
              id={editTeam._id}
              user={selected}
              name={typecall}
            />
          ) : null}
          {modletoggle && selected ? (
            <AddMemberModal
              modalClose={CloseForm}
              name={typecall}
              user={selected}
            />
          ) : null}
          {modletoggle1 ? (
            <AddMemberModal modalClose={CloseForm} name={typecall} />
          ) : null}
          {showAlert && error && (
            <AlertBox type="error" message={error} stateName={setShowAlert} />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default CreateTeam;
